<mat-toolbar
  style="
    background: linear-gradient(135deg, #1c593d 0%, #166534 50%, #14532d 100%);
    color: white;
    height: 64px;
    padding: 0 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  "
>
  <button
    type="button"
    (click)="sidenav.toggle()"
    title="Menu"
    style="
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background: rgba(255, 255, 255, 0.08);
      border: 1px solid rgba(255, 255, 255, 0.12);
      border-radius: 10px;
      cursor: pointer;
      color: white;
      transition: all 0.2s ease;
      flex-shrink: 0;
    "
    onmouseover="
      this.style.background = 'rgba(255,255,255,0.18)';
      this.style.borderColor = 'rgba(255,255,255,0.25)';
    "
    onmouseout="
      this.style.background = 'rgba(255,255,255,0.08)';
      this.style.borderColor = 'rgba(255,255,255,0.12)';
    "
  >
    <mat-icon>menu</mat-icon>
  </button>
  <div
    style="
      display: flex;
      align-items: center;
      margin-left: 12px;
      cursor: pointer;
    "
    routerLink="/wallet"
  >
    <div
      style="
        background: rgba(255, 255, 255, 0.12);
        border-radius: 12px;
        padding: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <img
        style="width: 32px; height: auto; filter: brightness(0) invert(1)"
        src="assets/img/LogoAW2025.png"
      />
    </div>
    <span
      class="hidden sm:inline"
      style="
        margin-left: 10px;
        font-weight: 700;
        font-size: 1.05rem;
        letter-spacing: 0.3px;
        color: white;
      "
      >Aguacate
      <span style="font-weight: 400; opacity: 0.85">Wallet</span></span
    >
  </div>
  <span class="toolbar-item-spacer"></span>
  <div class="flex flex-col items-end mr-3" style="min-width: 0; overflow: hidden;">
    <p
      style="
        margin: 0;
        font-size: 0.72rem;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.65);
        line-height: 1.2;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
      "
    >
      Bienvenido {{ userId }}
    </p>
    <span
      style="
        font-size: 0.85rem;
        font-weight: 600;
        color: white;
        line-height: 1.3;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
      "
      >{{ userName }}</span
    >
  </div>
  <!-- Notification bell -->
  <button
    type="button"
    [routerLink]="inboxRoute"
    title="Notificaciones"
    class="notification-bell"
    style="
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background: rgba(255, 255, 255, 0.08);
      border: 1px solid rgba(255, 255, 255, 0.12);
      border-radius: 10px;
      cursor: pointer;
      color: white;
      transition: all 0.2s ease;
      position: relative;
      margin-right: 8px;
      flex-shrink: 0;
    "
    onmouseover="
      this.style.background = 'rgba(255,255,255,0.18)';
      this.style.borderColor = 'rgba(255,255,255,0.25)';
    "
    onmouseout="
      this.style.background = 'rgba(255,255,255,0.08)';
      this.style.borderColor = 'rgba(255,255,255,0.12)';
    "
  >
    <mat-icon [class.notification-bell--active]="unreadMessages > 0">notifications</mat-icon>
    <span *ngIf="unreadMessages > 0" class="notification-badge">
      <span class="notification-badge__pulse"></span>
      <span class="notification-badge__count">{{ unreadMessages > 99 ? '99+' : unreadMessages }}</span>
    </span>
  </button>
  <button
    type="button"
    [matMenuTriggerFor]="userAccountMenu"
    title="Mi Cuenta"
    style="
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background: rgba(255, 255, 255, 0.08);
      border: 1px solid rgba(255, 255, 255, 0.12);
      border-radius: 10px;
      cursor: pointer;
      color: white;
      transition: all 0.2s ease;
      flex-shrink: 0;
    "
    onmouseover="
      this.style.background = 'rgba(255,255,255,0.18)';
      this.style.borderColor = 'rgba(255,255,255,0.25)';
    "
    onmouseout="
      this.style.background = 'rgba(255,255,255,0.08)';
      this.style.borderColor = 'rgba(255,255,255,0.12)';
    "
  >
    <mat-icon>account_circle</mat-icon>
  </button>
  <mat-menu
    #userAccountMenu
    [overlapTrigger]="false"
    yPosition="below"
    class="profile-menu"
  >
    <div style="padding: 12px 16px 8px; border-bottom: 1px solid #e5e7eb">
      <p
        style="
          margin: 0;
          font-size: 0.7rem;
          color: #9ca3af;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        "
      >
        Mi cuenta
      </p>
      <p
        style="
          margin: 2px 0 0;
          font-size: 0.85rem;
          color: #1c593d;
          font-weight: 700;
        "
      >
        {{ userName }}
      </p>
    </div>
    <button
      mat-menu-item
      routerLink="client/user-profile"
      [disabled]="!isEnabledUser"
      *ngIf="userRole === rolesEnum.aguacate_client"
      class="profile-menu-item"
    >
      <mat-icon style="color: #1c593d">person</mat-icon>
      <span>Mi perfil</span>
    </button>
    <div style="padding: 4px 8px">
      <button mat-menu-item (click)="signOut()" class="profile-menu-logout">
        <mat-icon style="color: #dc2626">logout</mat-icon>
        <span>Cerrar sesión</span>
      </button>
    </div>
  </mat-menu>
</mat-toolbar>

<mat-sidenav-container class="app-container">
  <mat-sidenav
    #sidenav
    mode="push"
    opened="false"
    [class.mat-elevation-z4]="true"
    class="app-sidenav"
  >
    <!-- Sidenav Header -->
    <div class="sidenav-header">
      <div class="sidenav-logo-container">
        <img
          src="assets/img/LogoAW2025.png"
          style="width: 36px; height: auto"
        />
      </div>
      <div>
        <span class="sidenav-brand">Aguacate</span>
        <span class="sidenav-brand-light">Wallet</span>
      </div>
    </div>

    <mat-nav-list class="sidenav-list">
      <mat-list-item
        routerLink="/wallet"
        class="menu-element"
        (click)="closeSidenav(sidenav)"
      >
        <span class="menu-item-content">
          <mat-icon class="menu-icon">home</mat-icon>
          <span>Inicio</span>
        </span>
      </mat-list-item>

      <!-- Menu usuario VE -->
      <ng-container *ngIf="userRole === rolesEnum.aguacate_client && tipoId === 'VE'">
        <div class="menu-section-label">Operaciones</div>

        <mat-list-item
          routerLink="/wallet/client/orders"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">receipt_long</mat-icon>
            <span>Historial de transacciones</span>
          </span>
        </mat-list-item>

        <!-- Descarga del historial completo en Excel.
             NO navega: dispara la descarga y avisa con el snackbar lateral, asi
             que el cliente puede seguir usando la app mientras se genera. El
             item queda deshabilitado mientras dura porque un segundo click
             gasta una de sus descargas del dia y le devuelve un 429. -->
        <mat-list-item
          class="menu-element"
          [class.menu-element-ocupado]="descargandoHistorial"
          [attr.aria-disabled]="descargandoHistorial"
          (click)="descargarHistorial(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">download</mat-icon>
            <span>{{ descargandoHistorial ? 'Preparando historial…' : 'Descargar mi historial' }}</span>
          </span>
        </mat-list-item>

        <!-- Remesas — cotizador unificado. Reemplaza al modal viejo
             (mismo nombre e ícono, sin paso intermedio). -->
        <mat-list-item
          routerLink="client/enviar"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">send</mat-icon>
            <span>Remesas</span>
          </span>
        </mat-list-item>

        <mat-list-item
          routerLink="client/recipients"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">assignment_ind</mat-icon>
            <span>Beneficiarios</span>
          </span>
        </mat-list-item>

        <mat-list-item
          routerLink="client/referencias-ves"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">description</mat-icon>
            <span>Depósitos VES</span>
          </span>
        </mat-list-item>

        <div class="menu-section-label">USDT & VES</div>

        <mat-list-item
          routerLink="client/load-pays-usdt"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">account_balance_wallet</mat-icon>
            <span>Depositar USDT</span>
          </span>
        </mat-list-item>

        <mat-list-item
          routerLink="client/convert-ves-usdt"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">swap_horiz</mat-icon>
            <span>Comprar USDT (VES)</span>
          </span>
        </mat-list-item>

        <mat-list-item
          routerLink="client/convert-usdt-ves"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">currency_exchange</mat-icon>
            <span>Convertir USDT a VES</span>
          </span>
        </mat-list-item>

        <div class="menu-section-label">Retiros</div>

        <mat-list-item
          routerLink="client/withdraw-ves"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">payments</mat-icon>
            <span>Retiro VES</span>
          </span>
        </mat-list-item>

        <mat-list-item
          routerLink="client/send-usdt"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">output</mat-icon>
            <span>Retiro USDT</span>
          </span>
        </mat-list-item>

        <mat-list-item
          routerLink="client/recipient-cripto"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">account_balance</mat-icon>
            <span>Cuentas de retiro USDT</span>
          </span>
        </mat-list-item>

        <ng-container *ngIf="canSeePayers === 1">
          <div class="menu-section-label">Pagadores</div>

          <mat-list-item
            routerLink="client/payer-invitations"
            class="menu-element"
            (click)="closeSidenav(sidenav)"
          >
            <span class="menu-item-content">
              <mat-icon class="menu-icon">person_add_alt_1</mat-icon>
              <span>Crear pagador</span>
            </span>
          </mat-list-item>

          <mat-list-item
            routerLink="client/payerList"
            class="menu-element"
            (click)="closeSidenav(sidenav)"
          >
            <span class="menu-item-content">
              <mat-icon class="menu-icon">contacts</mat-icon>
              <span>Mis pagadores</span>
            </span>
          </mat-list-item>
        </ng-container>

        <!-- API de tasas: solo si el backend habilito la cuenta (api-externa-cuenta/estado). -->
        <ng-container *ngIf="apiExternaVisible">
          <div class="menu-section-label">Integraciones</div>

          <mat-list-item
            routerLink="client/api"
            class="menu-element"
            (click)="closeSidenav(sidenav)"
          >
            <span class="menu-item-content">
              <mat-icon class="menu-icon">api</mat-icon>
              <span>API de tasas</span>
            </span>
          </mat-list-item>
        </ng-container>

        <div class="menu-section-label">Invit&aacute; y gan&aacute;</div>

        <mat-list-item
          *ngIf="referidosVisible"
          routerLink="client/referidos"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">card_giftcard</mat-icon>
            <span>Mi usuario y referidos</span>
          </span>
        </mat-list-item>

        <mat-list-item
          routerLink="client/bonos"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">redeem</mat-icon>
            <span>Mis bonos</span>
          </span>
        </mat-list-item>

        <div class="menu-section-label">Notificaciones</div>

        <mat-list-item
          routerLink="/wallet/client/messages-inbox"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">inbox</mat-icon>
            <span>Mis notificaciones</span>
          </span>
        </mat-list-item>

        <div class="menu-section-label">Seguridad</div>

        <mat-list-item
          routerLink="/wallet/client/my-connections"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">history</mat-icon>
            <span>Mis conexiones</span>
          </span>
        </mat-list-item>
      </ng-container>

      <!-- Menu usuario no-VE -->
      <ng-container *ngIf="userRole === rolesEnum.aguacate_client && tipoId !== 'VE'">
        <div class="menu-section-label">Operaciones</div>

        <mat-list-item
          routerLink="/wallet/client/orders"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">receipt_long</mat-icon>
            <span>Historial de transacciones</span>
          </span>
        </mat-list-item>

        <!-- Descarga del historial completo en Excel.
             NO navega: dispara la descarga y avisa con el snackbar lateral, asi
             que el cliente puede seguir usando la app mientras se genera. El
             item queda deshabilitado mientras dura porque un segundo click
             gasta una de sus descargas del dia y le devuelve un 429. -->
        <mat-list-item
          class="menu-element"
          [class.menu-element-ocupado]="descargandoHistorial"
          [attr.aria-disabled]="descargandoHistorial"
          (click)="descargarHistorial(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">download</mat-icon>
            <span>{{ descargandoHistorial ? 'Preparando historial…' : 'Descargar mi historial' }}</span>
          </span>
        </mat-list-item>

        <!-- Remesas — cotizador unificado. Reemplaza al modal viejo
             (mismo nombre e ícono, sin paso intermedio). -->
        <mat-list-item
          routerLink="client/enviar"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">send</mat-icon>
            <span>Remesas</span>
          </span>
        </mat-list-item>

        <mat-list-item
          routerLink="client/recipients"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">assignment_ind</mat-icon>
            <span>Beneficiarios Remesas</span>
          </span>
        </mat-list-item>

        <!-- Bolívares del chileno: comprar y guardar VES en su propio saldo,
             y sacarlos (retiro VES, VES→USDT, VES→CLP a Chile) por las mismas
             pantallas del VE. Las remesas VES→COP/PEN no se ofrecen. Los
             movimientos VES están en el historial (pestaña VES).
             30/10/2026: el chileno no recarga bolívares. Se quitaron
             «Recargar bolívares» y «Depósitos VES» (la lista de referencias
             de esas recargas, que solo se crean desde la recarga VES). El VE
             conserva los suyos en su menú. -->
        <ng-container *ngIf="esChilenoConVes">
          <div class="menu-section-label">Bolívares</div>

          <mat-list-item
            *ngIf="puedeComprarBolivares"
            routerLink="client/comprar-bolivares"
            class="menu-element"
            (click)="closeSidenav(sidenav)"
          >
            <span class="menu-item-content">
              <mat-icon class="menu-icon">shopping_cart</mat-icon>
              <span>Comprar bolívares</span>
            </span>
          </mat-list-item>

          <mat-list-item
            routerLink="client/convert-usdt-ves"
            class="menu-element"
            (click)="closeSidenav(sidenav)"
          >
            <span class="menu-item-content">
              <mat-icon class="menu-icon">currency_exchange</mat-icon>
              <span>Convertir USDT a VES</span>
            </span>
          </mat-list-item>

          <mat-list-item
            routerLink="client/convert-ves-usdt"
            class="menu-element"
            (click)="closeSidenav(sidenav)"
          >
            <span class="menu-item-content">
              <mat-icon class="menu-icon">swap_horiz</mat-icon>
              <span>Comprar USDT (VES)</span>
            </span>
          </mat-list-item>

          <mat-list-item
            routerLink="client/withdraw-ves"
            class="menu-element"
            (click)="closeSidenav(sidenav)"
          >
            <span class="menu-item-content">
              <mat-icon class="menu-icon">payments</mat-icon>
              <span>Retiro VES</span>
            </span>
          </mat-list-item>

          <mat-list-item
            routerLink="client/enviar"
            [queryParams]="{ origen: 'VES', destino: 'CL' }"
            class="menu-element"
            (click)="closeSidenav(sidenav)"
          >
            <span class="menu-item-content">
              <mat-icon class="menu-icon">send</mat-icon>
              <span>Bolívares a Chile (CLP)</span>
            </span>
          </mat-list-item>
        </ng-container>

        <div class="menu-section-label">Cripto & Zelle</div>

        <mat-list-item
          routerLink="client/cripto-home"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">currency_bitcoin</mat-icon>
            <span>Criptomonedas</span>
          </span>
        </mat-list-item>

        <mat-list-item
          routerLink="client/recipient-cripto"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">people_alt</mat-icon>
            <span>Beneficiarios Cripto</span>
          </span>
        </mat-list-item>

        <mat-list-item
          routerLink="client/zelle-home"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">attach_money</mat-icon>
            <span>Zelle</span>
          </span>
        </mat-list-item>

        <mat-list-item
          routerLink="client/recipient-zelle"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">contacts</mat-icon>
            <span>Beneficiarios Zelle</span>
          </span>
        </mat-list-item>

        <mat-list-item
          routerLink="client/load-pays-usdt"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">account_balance_wallet</mat-icon>
            <span>Depositar USDT</span>
          </span>
        </mat-list-item>

        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
          *ngIf="canSeePayers === 1"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">people</mat-icon>
            <span>Pagadores</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="client/payer-invitations"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">person_add_alt_1</mat-icon>
                <span>Crear</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="client/payerList"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">contacts</mat-icon>
                <span>Mis pagadores</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">savings</mat-icon>
            <span>Retiros</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="client/withdraw"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">output</mat-icon>
                <span>Realizar retiro CLP</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="client/send-usdt"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">output</mat-icon>
                <span>Realizar retiro USDT</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="client/withdraw-accounts"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">account_balance</mat-icon>
                <span>Cuentas de retiro CLP</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="client/recipient-cripto"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">account_balance</mat-icon>
                <span>Cuentas de retiro USDT</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <!-- API de tasas: solo si el backend habilito la cuenta (api-externa-cuenta/estado). -->
        <ng-container *ngIf="apiExternaVisible">
          <div class="menu-section-label">Integraciones</div>

          <mat-list-item
            routerLink="client/api"
            class="menu-element"
            (click)="closeSidenav(sidenav)"
          >
            <span class="menu-item-content">
              <mat-icon class="menu-icon">api</mat-icon>
              <span>API de tasas</span>
            </span>
          </mat-list-item>
        </ng-container>

        <div class="menu-section-label">Invit&aacute; y gan&aacute;</div>

        <mat-list-item
          *ngIf="referidosVisible"
          routerLink="client/referidos"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">card_giftcard</mat-icon>
            <span>Mi usuario y referidos</span>
          </span>
        </mat-list-item>

        <mat-list-item
          routerLink="client/bonos"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">redeem</mat-icon>
            <span>Mis bonos</span>
          </span>
        </mat-list-item>

        <div class="menu-section-label">Notificaciones</div>

        <mat-list-item
          routerLink="/wallet/client/messages-inbox"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">inbox</mat-icon>
            <span>Mis notificaciones</span>
          </span>
        </mat-list-item>

        <div class="menu-section-label">Seguridad</div>

        <mat-list-item
          routerLink="/wallet/client/my-connections"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">history</mat-icon>
            <span>Mis conexiones</span>
          </span>
        </mat-list-item>
      </ng-container>

      <!-- Menu operario -->
      <ng-container *ngIf="userRole === rolesEnum.aguacate_operator">
        <div class="menu-section-label">General</div>

        <!--
          Marketing agrupa los dos programas que reparten plata para traer
          clientes: Referidos (el link con la llave) y Bonos (el codigo que el
          cliente escribe). Links de campana no paga nada: mide el link que se
          le entrega a Marketing para redes.

          Estaban sueltos en el primer nivel y competian en atencion con
          operaciones y compliance, que se usan todos los dias. Son el mismo
          trabajo con dos mecanicas distintas, asi que van juntos y detras de un
          clic — igual que Compliance, que ya usa este mismo panel.
        -->
        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">campaign</mat-icon>
            <span>Marketing</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="admin/referidos"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">card_giftcard</mat-icon>
                <span>Referidos</span>
              </span>
            </mat-list-item>

            <mat-list-item
              routerLink="admin/bonos"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">redeem</mat-icon>
                <span>Bonos</span>
              </span>
            </mat-list-item>

            <mat-list-item
              routerLink="admin/marketing-links"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">link</mat-icon>
                <span>Links de campaña</span>
              </span>
            </mat-list-item>

            <mat-list-item
              routerLink="admin/recordatorio"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">mark_email_unread</mat-icon>
                <span>Recordatorio de inactividad</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <!-- Clientes API: quien puede consultar la API de tasas. Modulo propio, no es parte de compliance.
             La ruta es hermana de `admin` (ninguna ruta puede decir «admin»); el OperatorGuard va en la ruta. -->
        <mat-list-item
          routerLink="clientes-api-control"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">vpn_key</mat-icon>
            <span>Clientes API</span>
          </span>
        </mat-list-item>

        <!--
          Seguimiento de clientes: el plan de retencion de la mesa USDT.
          Va debajo de Bonos y lo ve cualquier operador — no hay permiso por
          dueno: la cuenta tiene dueno para saber quien responde, no para
          esconderle el tablero al resto del equipo.
        -->
        <mat-list-item
          routerLink="admin/seguimiento"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">monitor_heart</mat-icon>
            <span>Seguimiento de clientes</span>
          </span>
        </mat-list-item>



        <mat-list-item
          routerLink="/wallet/admin/dashboard-operation"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">bar_chart</mat-icon>
            <span>Dashboard de operaciones</span>
          </span>
        </mat-list-item>
        <mat-list-item
          routerLink="/wallet/admin/operations-history"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">history</mat-icon>
            <span>Historial de operaciones</span>
          </span>
        </mat-list-item>
        <!--
          Conciliacion de abonos: la plata que entro a cada cuenta de Aguacate
          (CLP, VES, USDT) y en que quedo. Solo operadores: esta dentro del
          bloque de operador, la ruta cuelga de `admin` (OperatorGuard) y el
          backend exige AguacateOperatorGuard.
        -->
        <mat-list-item
          routerLink="/wallet/admin/conciliacion-abonos"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">fact_check</mat-icon>
            <span>Conciliación de abonos</span>
          </span>
        </mat-list-item>
        <mat-list-item
          routerLink="/wallet/admin/manual-xls-bci"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">upload_file</mat-icon>
            <span>Carga Manual XLS BCI</span>
          </span>
        </mat-list-item>
        <mat-list-item
          routerLink="/wallet/admin/cash-closing-report"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">price_check</mat-icon>
            <span>Reporte cierre de caja</span>
          </span>
        </mat-list-item>
        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">verified_user</mat-icon>
            <span>Compliance</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="/wallet/admin/compliance-list"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">list_alt</mat-icon>
                <span>Lista de usuarios</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/data-update-requests"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">fact_check</mat-icon>
                <span>Actualización de datos</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/registro-beneficiarios"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">groups</mat-icon>
                <span>Registro de beneficiarios</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/payer-compliance"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">how_to_reg</mat-icon>
                <span>Pagadores por aprobar</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>
        <mat-list-item
          routerLink="/wallet/admin/transaction-cashier"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">payments</mat-icon>
            <span>Abonos/Debitos</span>
          </span>
        </mat-list-item>
        <mat-list-item
          routerLink="/wallet/admin/hours-operations"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">schedule</mat-icon>
            <span>Horario de operaciones</span>
          </span>
        </mat-list-item>
        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">people</mat-icon>
            <span>Conexiones</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="/wallet/admin/connected-users"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">wifi</mat-icon>
                <span>Usuarios conectados</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/connection-history"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">history</mat-icon>
                <span>Historial de conexiones</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/connection-analytics"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">analytics</mat-icon>
                <span>Analytics</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <div class="menu-section-label">Balances</div>

        <mat-list-item
          routerLink="/wallet/admin/balance-cajero"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">account_balance_wallet</mat-icon>
            <span>Balance Cajero</span>
          </span>
        </mat-list-item>
        <mat-list-item
          routerLink="/wallet/admin/balance-cbpay"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">wallet</mat-icon>
            <span>Balance CbPay</span>
          </span>
        </mat-list-item>
        <mat-list-item
          routerLink="/wallet/admin/user-balance"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">swap_horiz</mat-icon>
            <span>Movimientos de usuario</span>
          </span>
        </mat-list-item>
        <mat-list-item
          routerLink="/wallet/admin/user-segmentation"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">admin_panel_settings</mat-icon>
            <span>Roles de usuario</span>
          </span>
        </mat-list-item>
        <mat-list-item
          routerLink="/wallet/admin/status-cajero"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">request_quote</mat-icon>
            <span>Estatus cajero</span>
          </span>
        </mat-list-item>
        <mat-list-item
          routerLink="/wallet/admin/status-cajero-fiat"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">account_balance</mat-icon>
            <span>Estatus cajero fiat</span>
          </span>
        </mat-list-item>
        <mat-list-item
          routerLink="/wallet/admin/unassigned-transaction"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">report_problem</mat-icon>
            <span>Transacciones Rezagadas CLP</span>
          </span>
        </mat-list-item>

        <div class="menu-section-label">Transacciones</div>

        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">currency_exchange</mat-icon>
            <span>Transacciones VES</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="/wallet/admin/transactions"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">list_alt</mat-icon>
                <span>Lista de transacciones VES</span>
              </span>
            </mat-list-item>
            <mat-list-item
              [routerLink]="['/wallet/admin/pending-transactions-binance']"
              [queryParams]="{ bankType: 'BINANCE' }"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">currency_bitcoin</mat-icon>
                <span>Pendientes Binance</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/pending-transactions"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">hourglass_top</mat-icon>
                <span>Transacciones pendientes</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/completed-ves-transactions"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">check_circle</mat-icon>
                <span>Transacciones VES completadas</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/cbpay-view-list"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">credit_card</mat-icon>
                <span>Transacciones CBPAY Walet</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">account_balance_wallet</mat-icon>
            <span>Wallet VES</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="/wallet/admin/wallets-usdt-ves-report"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">assessment</mat-icon>
                <span>Reporte USDT/VES</span>
              </span>
            </mat-list-item>
<mat-list-item
              routerLink="/wallet/admin/transactions-ves"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">receipt_long</mat-icon>
                <span>Transacciones VES</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/referencias-ves-admin"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">description</mat-icon>
                <span>Carga Saldo VES Cliente</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/bancos-activos-ves"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">account_balance</mat-icon>
                <span>Bancos Activos VES</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">atm</mat-icon>
            <span>Transacciones de retiro FIAT</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              [routerLink]="['/wallet/admin/withdraw-transactions']"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">output</mat-icon>
                <span>Transacciones de Retiro</span>
              </span>
            </mat-list-item>
            <mat-list-item
              [routerLink]="['/wallet/admin/withdraw-transactions-sent']"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">done_all</mat-icon>
                <span>Historial de pago Retiros FIAT</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">token</mat-icon>
            <span>Criptomonedas</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="/wallet/admin/cripto-rate"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">trending_up</mat-icon>
                <span>Tasa negociación</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/pending-transactons-cripto"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">pending_actions</mat-icon>
                <span>Transacciones Criptomonedas</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/manual-transaction"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">edit_note</mat-icon>
                <span>Transacciones Manuales</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">attach_money</mat-icon>
            <span>Zelle</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="/wallet/admin/zelle-rate"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">trending_up</mat-icon>
                <span>Tasa negociación</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/pending-transactions-zelle"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">hourglass_top</mat-icon>
                <span>Transacciones pendientes Zelle</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <div class="menu-section-label">Cuentas</div>

        <mat-list-item
          routerLink="/wallet/admin/working-account"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">work</mat-icon>
            <span>Cuentas de trabajo</span>
          </span>
        </mat-list-item>
        <mat-list-item
          routerLink="/wallet/admin/cuentas-activas-ves"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">fact_check</mat-icon>
            <span>Cuentas activas VES</span>
          </span>
        </mat-list-item>
        <mat-list-item
          routerLink="/wallet/admin/active-accounts"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">business</mat-icon>
            <span>Cuentas activas</span>
          </span>
        </mat-list-item>
        <mat-list-item
          routerLink="/wallet/admin/billing-record"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">description</mat-icon>
            <span>Facturas exentas</span>
          </span>
        </mat-list-item>

        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">dashboard</mat-icon>
            <span>Admin Wallets Pays</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="/wallet/admin/admin-wallets"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">dns</mat-icon>
                <span>Admin Wallets</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/wallets-usdt-clp-report"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">assessment</mat-icon>
                <span>Reporte USDT/CLP conversión</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/wallets-usdt-ves-report"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">assessment</mat-icon>
                <span>Reporte USDT/VES conversión</span>
              </span>
            </mat-list-item>
<mat-list-item
              routerLink="/wallet/admin/transactions-ves"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">receipt_long</mat-icon>
                <span>Transacciones VES</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/wallets-admin-send-usdt"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">send</mat-icon>
                <span>Administrar envío USDT</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/wallets-conciliator"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">balance</mat-icon>
                <span>Conciliador Wallets</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/list-pays-wallets-operator"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">description</mat-icon>
                <span>Abonos En Wallet</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/binance-search-by-wallet"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">search</mat-icon>
                <span>Buscar por Wallet</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/validar-wallet"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">gpp_maybe</mat-icon>
                <span>Validar Wallet</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/responsable-wallet"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">account_balance_wallet</mat-icon>
                <span>Responsable por Wallet</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <!--
          Panel "Binance Links" — SIEMPRE visible para OPERADORES en todos
          los ambientes. El bloque externo *ngIf="userRole === aguacate_operator"
          ya bloquea a clientes. NO se ata a `binanceLinkEnabled`: ese flag
          deshabilita el uso de Binance Link del lado CLIENTE (recargas) y la
          oferta post-aprobación, pero el operador mantiene la gestión de
          wallets desde acá.
        -->
        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">link</mat-icon>
            <span>Binance Links</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="/wallet/admin/wallets-usuarios"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">account_balance_wallet</mat-icon>
                <span>Wallets Usuarios</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/binance-link-subaccounts"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">group_add</mat-icon>
                <span>Creación de sub-cuentas</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/binance-centralizations"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">sync_alt</mat-icon>
                <span>Centralizaciones</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <div class="menu-section-label">Notificaciones</div>

        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">notifications</mat-icon>
            <span>Notificaciones</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="/wallet/admin/messages-inbox"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">inbox</mat-icon>
                <span>Bandeja de entrada</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/messages-send"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">send</mat-icon>
                <span>Enviar notificación</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <div class="menu-section-label">Configuración</div>

        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">settings</mat-icon>
            <span>Configuración</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="/wallet/admin/cripto-rate"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">currency_exchange</mat-icon>
                <span>Tasas de cambio</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/set-rates-parameters"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">tune</mat-icon>
                <span>Parámetros tasa automática</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/set-rates-sales-parameters"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">tune</mat-icon>
                <span>Parámetros tasa de venta</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/set-rates-parameters-bolivares"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">tune</mat-icon>
                <span>Parámetros tasa bolivares</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/comisiones-bancarias"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">account_balance</mat-icon>
                <span>Comisiones Bancarias VES</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/admin-whatsapp-otp"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">chat</mat-icon>
                <span>WhatsApp OTP</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <ng-container *ngIf="showDenounceMenu">
          <div class="menu-section-label">Canal Denuncias</div>

          <mat-list-item
            routerLink="/wallet/admin/denounces"
            class="menu-element"
            (click)="closeSidenav(sidenav)"
          >
            <span class="menu-item-content">
              <mat-icon class="menu-icon">report_problem</mat-icon>
              <span>Denuncias</span>
            </span>
          </mat-list-item>

          <mat-list-item
            *ngIf="denounceRole === 'ADMIN'"
            routerLink="/wallet/admin/denounces/access"
            class="menu-element"
            (click)="closeSidenav(sidenav)"
          >
            <span class="menu-item-content">
              <mat-icon class="menu-icon">admin_panel_settings</mat-icon>
              <span>Gestión Accesos</span>
            </span>
          </mat-list-item>
        </ng-container>

        <ng-container *ngIf="showAgentChat">
          <div class="menu-section-label">Aguacate AI</div>

          <mat-list-item
            routerLink="/wallet/admin/agent-chat"
            class="menu-element"
            (click)="closeSidenav(sidenav)"
          >
            <span class="menu-item-content">
              <mat-icon class="menu-icon">smart_toy</mat-icon>
              <span>Chat AI</span>
            </span>
          </mat-list-item>
        </ng-container>

        <div class="menu-section-label">Banco N58</div>

        <mat-list-item
          routerLink="/wallet/admin/n58"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">account_balance</mat-icon>
            <span>Dashboard N58</span>
            <span class="n58-sidebar-dot" [class.n58-health-ok]="n58Health?.operational" [class.n58-health-down]="n58Health !== null && !n58Health.operational"></span>
          </span>
        </mat-list-item>

        <div class="menu-section-label">Banco Plaza</div>

        <mat-list-item
          routerLink="/wallet/admin/banco-plaza"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">account_balance</mat-icon>
            <span>Dashboard Banco Plaza</span>
            <span class="n58-sidebar-dot" [class.n58-health-ok]="bancoPlazaHealth?.status === 'ok'" [class.n58-health-down]="bancoPlazaHealth !== null && bancoPlazaHealth.status !== 'ok'"></span>
          </span>
        </mat-list-item>

        <div class="menu-section-label">R4 Conecta</div>

        <mat-list-item
          routerLink="/wallet/admin/r4"
          class="menu-element"
          (click)="closeSidenav(sidenav)"
        >
          <span class="menu-item-content">
            <mat-icon class="menu-icon">account_balance</mat-icon>
            <span>Dashboard R4 Conecta</span>
          </span>
        </mat-list-item>

        <div class="menu-section-label">Vita Wallet</div>

        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">account_balance_wallet</mat-icon>
            <span>Dashboard Vita</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="/wallet/admin/vita-dashboard"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">dashboard</mat-icon>
                <span>Dashboard</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/vita-registro"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">receipt_long</mat-icon>
                <span>Registro Vita</span>
              </span>
            </mat-list-item>
            <mat-list-item
              *ngIf="vitaMovimientosEnSidebar"
              routerLink="/wallet/admin/vita-movimientos"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">swap_vert</mat-icon>
                <span>Movimientos Vita</span>
              </span>
            </mat-list-item>
          </mat-nav-list>
        </mat-expansion-panel>

        <div class="menu-section-label">TRM RAILS</div>

        <mat-expansion-panel
          [class.mat-elevation-z0]="true"
          class="menu-expansion"
        >
          <mat-expansion-panel-header>
            <mat-icon class="menu-icon">flag</mat-icon>
            <span>DATA TRM RAILS</span>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <mat-list-item
              routerLink="/wallet/admin/rail-colombia"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">trending_up</mat-icon>
                <span>TRM USD/COP</span>
              </span>
            </mat-list-item>
            <mat-list-item
              routerLink="/wallet/admin/rail-peru"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">trending_up</mat-icon>
                <span>TRM USD/PEN</span>
              </span>
            </mat-list-item>
            <!-- Calculadora Rail Colombia oculta temporalmente -->
            <!-- <mat-list-item
              routerLink="/wallet/admin/rail-colombia-calculadora"
              class="menu-element"
              (click)="closeSidenav(sidenav)"
            >
              <span class="menu-item-content">
                <mat-icon class="menu-icon">calculate</mat-icon>
                <span>Calculadora</span>
              </span>
            </mat-list-item> -->
          </mat-nav-list>
        </mat-expansion-panel>
      </ng-container>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content class="sidenav-content">
    <div class="app-sidenav-content">
      <router-outlet></router-outlet>

      <!-- Markup fuera de banda, ya reconocido por el operador: queda la
           píldora con la cuenta regresiva hasta que el aviso vuelva. El modal
           lo abre el componente, no el template. -->
      <div
        *ngIf="avisoMarkup && !avisoMarkup.mostrarModal"
        style="
          position: fixed;
          left: 50%;
          bottom: 22px;
          transform: translateX(-50%);
          z-index: 90;
          display: inline-flex;
          align-items: center;
          gap: 10px;
          max-width: calc(100vw - 32px);
          background: white;
          border: 1px solid #fecaca;
          border-left: 4px solid #ef4444;
          border-radius: 999px;
          padding: 9px 18px;
          box-shadow: 0 4px 16px rgba(220, 38, 38, 0.18);
        "
      >
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #dc2626;">
          warning
        </mat-icon>
        <span style="font-size: 0.8rem; font-weight: 600; color: #b91c1c;">
          Markup {{ avisoMarkup.verificacion.markupPct >= 0 ? '+' : ''
          }}{{ avisoMarkup.verificacion.markupPct | number: '1.2-2' }}% · encargado avisado
        </span>
        <span style="font-size: 0.78rem; color: #6b7280; font-family: monospace;">
          vuelve en {{ avisoMarkup.segundosParaReaparecer * 1000 | date: 'm:ss':'UTC' }}
        </span>
      </div>
      <!-- Chatbot widget oculto temporalmente para operadores -->
      <!-- <app-agent-chat-widget *ngIf="userRole === rolesEnum.aguacate_operator"></app-agent-chat-widget> -->
      <div
        class="fab-container"
        *ngIf="userRole === rolesEnum.aguacate_client && !isCompanyRegistration"
      >
        <button
          type="button"
          (click)="abrirAyuda()"
          title="Ayuda"
          aria-label="Ayuda"
          style="
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 56px;
            height: 56px;
            background: #1c593d;
            color: white;
            border: none;
            border-radius: 50%;
            cursor: pointer;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
            transition: all 0.2s ease;
          "
          onmouseover="
            this.style.background = '#059669';
            this.style.transform = 'scale(1.08)';
          "
          onmouseout="
            this.style.background = '#1C593D';
            this.style.transform = 'scale(1)';
          "
        >
          <mat-icon>contact_support</mat-icon>
        </button>
      </div>
      <app-asistente-cliente
        *ngIf="asistenteAbierto && userRole === rolesEnum.aguacate_client"
        (cerrar)="asistenteAbierto = false"
      ></app-asistente-cliente>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
